<template>
  <div>
    <a-modal
      :title="title"
      :visible="searchVisible"
      :footer="null"
      class="modalStyle"
      @cancel="handleCancel"
    >
      <div>
        <div class="l-contain padding-bottom-xs">
          <!-- <h3
          class="text-14 margin-0 text-center margin-bottom-sm"
          style="font-weight: 400"
        >
          请输入需要绑定的商品名称
        </h3> -->
          <div class="l-input flex justify-between align-center">
            <input
              class="l-inp"
              v-model="inputProductName"
              type="text"
              placeholder="请输入名称"
            />
            <a-icon
              type="search"
              @click="handleSearchPro"
              class="
                el-icon-search
                text-26 text-bold text-777
                l-hand-change
                padding-lr-xs
              "
            />
          </div>
          <!-- <div class="margin-top-xs" style="color: #9a9a9a">
          输入商品名称搜索，可绑定商品
        </div> -->
          <div class="l-product-list flex justify-start">
            <div
              class="l-product-item l-hand-change"
              v-for="(item, index) of searchProduct"
              :key="index"
              @click="selectPro(item, index)"
            >
              <div
                v-if="item.check"
                class="
                  l-product-item-mask l-hand-change
                  flex
                  justify-center
                  align-center
                "
              >
                <i
                  class="text-26 text-bold text-777 padding-lr-xs"
                  style="color: white"
                >
                  <a-icon type="check" />
                </i>
              </div>
              <div
                style="width: 100px; height: 100px; overflow: hidden"
                class="flex justify-center align-center"
              >
                <img style="width: 100px" :src="item.goods_image" alt="" />
              </div>
              <div class="l-spmc">{{ item.goods_name }}</div>
            </div>
            <div class="nodata" v-if="searchProduct.length == 0">
              暂无数据。。。
            </div>
          </div>
          <div class="l-btn flex justify-center align-center margin-tb-sm">
            <div
              class="
                l-confirm l-hand-change
                flex
                align-center
                justify-center
                margin-right-sm
              "
              @click="confirmBtn"
            >
              确认
            </div>
            <div
              @click="cancelBtn"
              class="l-cancel l-hand-change flex align-center justify-center"
            >
              取消
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
//接口需要更换
import { projectShopList, getProxyGoodsSelectList } from "@/service/goods";
export default {
  name: "SearchProduct",
  props: {
    // 添加单个商品 或 多个商品
    single: {
      type: Boolean, //指定传入的类型
      //type 也可以是一个自定义构造器函数，使用 instanceof 检测。
      default: false, //这样可以指定默认的值
    },
    // 已有商品列表id ， 已存在的商品列表搜索不出来
    selectedid: {
      type: Array, //指定传入的类型
      //type 也可以是一个自定义构造器函数，使用 instanceof 检测。
      default: () => [], //这样可以指定默认的值
    },
    searchContent: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: "添加",
    },
    //1商品 2人员 3服务商
    dialogType: {},
    status: {}, //商品状态0违禁下架1正常"
  },
  data() {
    return {
      inputProductName: "",
      searchVisible: false,
      searchProduct: [],
    };
  },
  created() {},
  mounted() {
    // if (this.searchContent) {
    //   this.inputProductName = this.searchContent;
    //   this.searchPro();
    // } else {
    // }
  },
  methods: {
    showModal() {
      this.$nextTick(() => {
        console.log("弹窗类型", 111, this.dialogType);
        if (this.dialogType == 2) {
          this.proxySearchPro();
          this.searchVisible = true;
        } else {
          this.searchPro();
          this.searchVisible = true;
        }
      });
    },
    handleSearchPro() {
      if (this.dialogType == 2) {
        this.proxySearchPro();
      } else {
        this.searchPro();
      }
    },
    handleOk(e) {
      setTimeout(() => {
        this.searchVisible = false;
      }, 20);
    },
    handleCancel(e) {
      this.inputProductName = null;
      this.searchProduct = [];
      this.searchVisible = false;
    },
    searchPro() {
      projectShopList({
        goods_name: this.inputProductName,
        shop_id: localStorage.getItem("amallSystemId"),
        page: 1,
        size: 20,
      }).then((res) => {
        if (res.data.total > 0) {
          let arr = [];
          res.data.rows.forEach((element) => {
            element.goods_image = element.goods_image.split(",")[0];
            element.check = false;
            if (this.selectedid.indexOf(element.goods_id) == -1) {
              arr.push(element);
            }
          });
          this.searchProduct = arr;
        } else {
          this.searchProduct = [];
        }
      });
    },
    //代理人商品搜索
    proxySearchPro() {
      getProxyGoodsSelectList({
        goods_name: this.inputProductName,
        page: 1,
        size: 20,
      }).then((res) => {
        console.log("代理人商品搜索", res.data);
        if (res.flag) {
          if (res.data.total > 0) {
            let arr = [];
            res.data.rows.forEach((element) => {
              element.goods_image = element.goods_image.split(",")[0];
              element.check = false;
              if (this.selectedid.indexOf(element.goods_id) == -1) {
                arr.push(element);
              }
            });
            this.searchProduct = arr;
          }else {
            this.searchProduct = [];
          }
        }
      });
    },
    selectPro(item, index) {
      let _this = this;
      if (this.single) {
        this.searchProduct.forEach((its, idx) => {
          if (idx != index) {
            this.searchProduct[idx].check = false;
          }
        });
        this.searchProduct[index].check = !this.searchProduct[index].check;
      } else {
        this.searchProduct[index].check = !this.searchProduct[index].check;
      }
    },
    confirmBtn() {
      let selectArr = [];
      this.searchProduct.forEach((item) => {
        if (item.check) selectArr.push(item);
      });
      this.$emit("confirm", selectArr);
      this.handleCancel();
    },
    cancelBtn() {
      this.searchProduct = [];
      // this.inputProductName = "";
      this.handleCancel();
    },
  },
};
</script>
 
<style scoped lang='scss'>
.modalStyle >>> .ant-modal-wrap {
  z-index: 999999999;
}
.box {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999999;
}
.l-title {
  width: 600px;
  min-height: 400px;
  border-radius: 20px;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
}
.l-contain {
  width: 400px;
  min-height: 340px;
  margin: 0 auto;
  .l-input {
    width: 400px;
    border: 1px solid #e7e7eb;
    height: 36px;
    padding: 0 0 0 10px;
    box-sizing: border-box;
    border-radius: 3px;
    .l-inp {
      width: 340px;
      height: 30px;
      border: none;
    }
    .l-inp:focus {
      outline: none;
    }
  }
  .l-product-list {
    width: 340px;
    height: 300px;
    overflow: auto;
    margin: 10px auto;
    box-sizing: border-box;
    flex-wrap: wrap;
    .l-product-item {
      width: 100px;
      height: 130px;
      margin-right: 10px;
      margin-bottom: 18px;
      position: relative;
    }
    .l-product-item-mask {
      background: rgba(0, 0, 0, 0.3);
      position: absolute;
      width: 100px;
      height: 130px;
      opacity: 1;
    }
    // .l-product-item:hover .l-product-item-mask {
    //   opacity: 1;
    //   background: rgba(0, 0, 0, 0.3);
    //   position: absolute;
    //   width: 100px;
    //   height: 130px;
    //   z-index: 1;
    // }
  }
  .l-btn {
    .l-confirm {
      width: 96px;
      height: 36px;
      background: #07c160;
      border-radius: 3px;
      color: white;
    }
    .l-cancel {
      width: 96px;
      height: 36px;
      background: #f6f7f8;
      border-radius: 3px;
      color: black;
      border: 1px solid #e3e4e5;
    }
  }
}
.l-spmc {
  margin-top: 10px;
  width: 100px;
  height: 20px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.nodata {
  width: 100%;
  height: 200px;
  line-height: 200px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/searchGoods/index.vue